import customizeValidator from './customizeValidator.js';
import createPrecompiledValidator from './createPrecompiledValidator.js';
export { customizeValidator, createPrecompiledValidator };
export * from './types.js';
export default customizeValidator();
//# sourceMappingURL=index.js.map